
export class CheckRawVisitCriteria {
    MemberNumberNotExist: boolean;
    MemberStatusInvalid: boolean;
    MemberIneligible: boolean;
    FacilityServiceComboInactive: boolean;
}

